import { VIDEO_PLATFORM, VideoPlatform } from 'js/lib/constants'

type Options = {
    youtube?: {
        enabled: boolean
    }
    vimeo?: {
        enabled: boolean
    }
    kaltura?: {
        enabled: boolean
        partnerId: string
        playerId: string
    }
    blueBillywig?: {
        enabled: boolean
        playoutId: string
        partnerId: string
    }
}

/**
 * Returns a list of enabled video platforms based on the given options.
 *
 * This check ensures that platforms like Kaltura and BlueBillywig are only
 * enabled if the required settings are provided, and the services are actually
 * enabled in the settings.
 *
 * @param options - The options to use to determine which video platforms are enabled.
 * @returns A list of enabled video platforms.
 */
function enabledVideoPlatforms({
    vimeo = { enabled: true },
    youtube = { enabled: true },
    kaltura,
    blueBillywig,
}: Options): VideoPlatform[] {
    return [].concat(
        youtube?.enabled // *
            ? VIDEO_PLATFORM.Youtube
            : [],
        vimeo?.enabled // *
            ? VIDEO_PLATFORM.Vimeo
            : [],
        kaltura?.enabled && // *
            kaltura?.partnerId &&
            kaltura?.playerId
            ? VIDEO_PLATFORM.Kaltura
            : [],
        blueBillywig?.enabled && // *
            blueBillywig?.playoutId &&
            blueBillywig?.partnerId
            ? VIDEO_PLATFORM.BlueBillywig
            : [],
    ) satisfies VideoPlatform[]
} // *) because prettier makes an unreadable mess of the formatting.

export default enabledVideoPlatforms
